import React, { useEffect, useState } from "react";
import {
  Form,
  ButtonToolbar,
  Button,
  InputGroup,
  Input,
  InputNumber,
  Heading,
  HeadingGroup,
  Text,
  DatePicker,
  Stack,
  DateInput,
  Message,
  toaster,
  SelectPicker,
  Modal,
} from "rsuite";
import axios from "../axiosIn";
import { variables } from "../Variables";
import { LuFileEdit } from "react-icons/lu";
import moment from "moment/moment";


export const DatosCarrera = () => {
  const [fechaCarrera, setFechaCarrera] = useState("");
  const [fechaTexto, setFechaTexto] = useState("");
  const [pista, setPista] = useState("");
  const [strava, setStrava] = useState("");
  const [rutas, setRutas] = useState([{ label: "+ Agregar Ruta", value: "0" }]);
  const [linkPista, setLinkPista] = useState("");
  const [ubicacion, setUbicacion] = useState("");
  const [logo, setLogo] = useState(null);
  const [logoName, setLogoName] = useState("");
  const [imagen, setImagen] = useState(null);
  const [imagenName, setImagenName] = useState("");
  const [benef, setBenef] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [formatCard, setFormatCard] = useState("");
  const [invalidCard, setInvalidCard] = useState("");
  const [clabe, setClabe] = useState("");
  const [clabeFormato, setClabeFormato] = useState("");
  const [invalidClabe, setInvalidClabe] = useState("");
  const [fechaCierre, setFecCierre] = useState("");
  const [horaCierre, setHoraCierre] = useState("18:00");
  const [fecRecon1, setFecRecon1] = useState("");
  const [horaRec1, setHoraRec1] = useState("08:00");
  const [fecRecon2, setFecRecon2] = useState("");
  const [horaRec2, setHoraRec2] = useState("08:00");
  const [docConvoca, setDocConvoca] = useState(null);
  const [docConvocaName, setDocConvocaName] = useState("");
  const [disabledOk, setDisabledOk] = useState(false);
  const [camposIncompletos, setCampos] = useState("");
  const [display, setDisplay] = useState("none");
  const [banco, setBanco] = useState("");
  const [precio, setPrecio] = useState("");
  const [camposInvalidos, setCamposInvalidos] = useState(false);
  const [numRutas, setNumRutas] = useState(0);

  const [editLogo, setEditLogo] = useState(false);
  const [editImagen, setEditImagen] = useState(false);
  const [editDoc, setEditDoc] = useState(false);
  const [editando, setEditando] = useState(false);
  const [editFecRecon1, setEditFecRecon1] = useState(false);
  const [editFecRecon2, setEditFecRecon2] = useState(false);

  const [idRuta, setIdRuta] = useState(0);
  const [distancia, setDistancia] = useState("");
  const [tiempo, setTiempo] = useState("");
  const [altitud, setAltitud] = useState("");
  const [rutaStrava, setRutaStrava] = useState("");

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const validSession = () => {
    var sessionID = getCookie("sessionID");
    var expira = getCookie("expira");
    var user = getCookie("user");
    var dateIsAfter = moment(new Date()).isAfter(moment(expira));

    if (sessionID.length === 0) {
      window.location = `/#/Login`;
      window.location.reload();
    }

    if (expira.length > 0) {
      if (dateIsAfter) {
        window.location = `/#/Login`;
        window.location.reload();
      }
    }
  };

  const getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  const onHandleCardNumberChange = (campo, value) => {
    const onlyNums = value.replace(/[^0-9]/g, "");

    switch (campo) {
      case "tarjeta":
        setCardNumber(onlyNums);
        break;
      default:
        setClabe(onlyNums);
        break;
    }
  };

  const addRuta = (e) => {
    if(e != null){
      if (!fechaCarrera) {
        toast("Debes seleccionar una fecha antes de continuar.", "warning");
        return;
      }
      
      setDistancia('');
      setTiempo('');
      setAltitud('');
      setRutaStrava('');

      if (e!="0"){
        getDataRuta(e);
      }else{
        setIdRuta(0);
      }
      
      setTimeout(() => {
        setOpen(true);
      }, 100);
    }
  };

  const formatCardNumber = async () => {
    var url = `DatosCarrera/GetFormatCard/${cardNumber}`;

    if (!cardNumber) {
      setFormatCard("");
      return;
    }
    if (cardNumber.length < 16) {
      setInvalidCard("El número de tarjeta no es valido.");
    } else {
      setInvalidCard("");
    }

    await axios
      .get(url)
      .then((res) => {
        setFormatCard(res.data);
        return res.status;
      })
      .catch((err) => console.error(err));
  };

  const formatClabe = async () => {
    var url = `DatosCarrera/GetFormatClabe/${clabe}`;

    if (!clabe) {
      setClabeFormato("");
      return;
    }
    if (clabe.length < 18) {
      setInvalidClabe("El número de tarjeta no es valido.");
    } else {
      setInvalidClabe("");
    }

    await axios
      .get(url)
      .then((res) => {
        setClabeFormato(res.data);
      })
      .catch((err) => console.error(err));
  };

  const getDataCarrera = async () => {
    if (!fechaCarrera) {
      return;
    }
    const _fecha = new Date(fechaCarrera).toISOString();
    console.log(_fecha);
    var url = `DatosCarrera/getDataCarrera/${_fecha}`;

    await axios
      .post(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        console.log(res.status);
        if (res.status === 204) {
          loadRutas();
          return;
        }
        setPista(res.data.NombrePista);
        setFechaTexto(res.data.TextFecha);
        setStrava(res.data.Strava);
        setLinkPista(res.data.LinkUbicacion);
        setUbicacion(res.data.TextUbicacion);
        setLogoName(res.data.LogoEquipo);
        setImagenName(res.data.ImagenFondo);
        setBenef(res.data.NomBeneficiario);
        setCardNumber(res.data.NumTarjeta);
        setClabe(res.data.Clabe);
        setFecCierre(res.data.FechaCierre);
        setHoraCierre(res.data.HoraCierre);
        setFecRecon1(res.data.FechaRecon1);
        setFecRecon2(res.data.FechaRecon2);
        setDocConvocaName(res.data.DocConvoca);
        setFormatCard(res.data.formatoTarjeta);
        setClabeFormato(res.data.formatoClabe);
        setBanco(res.data.Banco);
        setPrecio(res.data.Precio);
        setEditando(true); // FECHA DE CIERRE
        setEditLogo(true); // LOGO
        setEditImagen(true);
        setEditDoc(true);
        setEditFecRecon1(true);
        setEditFecRecon2(true);

        // VALIDAMOS SI EXISTE INFO DE LOGO, IMAGEN Y DOC
        if (!res.data.LogoEquipo) {
          setEditLogo(false);
        }
        if (!res.data.ImagenFondo) {
          setEditImagen(false);
        }
        if (!res.data.DocConvoca) {
          setEditDoc(false);
        }
        if (!res.data.FechaCierre) {
          setEditando(false);
        }
        if (!res.data.FechaRecon1) {
          setEditFecRecon1(false);
        }
        if (!res.data.FechaRecon2) {
          setEditFecRecon2(false);
        }
        loadRutas();
      })
      .catch((err) => console.error(err));
  };

  const handleInput = (campo, value) => {
    var newVal = value.toUpperCase();
    switch (campo) {
      case "pista":
        setPista(newVal);
        break;
      case "benef":
        setBenef(newVal);
        break;
      case "ubicacion":
        setUbicacion(newVal);
        break;
      case "banco":
        setBanco(newVal);
        break;
    }
  };

  const maskTime = (value) => {
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1:$2")
      .replace(/(\d{2})(\d)/, "$1:$2");
  };

  const formatStringDate = async () => {
    var url = `DatosCarrera/GetStringDate/${fechaCarrera}`;

    await axios
      .get(url)
      .then((res) => {
        setFechaTexto(res.data);
      })
      .catch((err) => console.error(err));
  };

  const handleChangeLogo = (e) => {
    if (e.target.value != "") {
      setLogo(e.target.files[0]);
      setLogoName(e.target.files[0].name);
    }
  };

  const handleChangeImagen = (e) => {
    if (e.target.value != "") {
      setImagen(e.target.files[0]);
      setImagenName(e.target.files[0].name);
    }
  };

  const handleChangeConvoca = (e) => {
    if (e.target.value != "") {
      setDocConvoca(e.target.files[0]);
      setDocConvocaName(e.target.files[0].name);
    }
  };

  const validInfo = () => {
    var validos = true;
    var campos = "";
    console.log(fechaTexto);
    if (!fechaCarrera) {
      campos = " Fecha de la carrera";
      validos = false;
    }
    if (!fechaTexto) {
      campos += ", Fecha en Texto";
      validos = false;
    }
    if (!pista) {
      campos += ", Nombre de la pista";
      validos = false;
    }
    if (!banco) {
      campos += ", Banco";
      validos = false;
    }
    if (!benef) {
      campos += ", Beneficiario";
      validos = false;
    }
    if (!cardNumber) {
      campos += ", No. de Tarjeta";
      validos = false;
    }
    if (!clabe) {
      campos += ", CLABE Interbancaria";
      validos = false;
    }
    if (!precio) {
      campos += ", Precio";
      validos = false;
    }
    if (!fechaCierre) {
      campos += ", Fecha de Cierre";
      validos = false;
    }
    if (!horaCierre) {
      campos += ", Hora de Cierre.";
      validos = false;
    }

    if (validos === false) {
      setDisplay("block");
    }

    setCampos(campos);
    setCamposInvalidos(validos);

    return validos;
  };

  const toast = (msg, type = "info") => {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  };

  const loadRutas = async () => {
    var _fecha = new Date(fechaCarrera).toISOString();
    var url = `DatosCarrera/GetRutas/${_fecha}`;
    await axios
      .get(url)
      .then((res) => {
        let _rutas = [{ label: "", value: "" }];
        res.data.map((c) =>
          _rutas.push({
            label: `${c.distancia}`,
            value: c.idRuta,
          })
        );
        _rutas.push({ label: "+ Agregar Ruta", value: "0"});
        setRutas(_rutas);
        var count = parseInt(_rutas.length)-2;
        setNumRutas(count);
      })
      .catch((err) => console.error(err));
  };

  const getDataRuta = async (ruta) => {
    var url = `DatosCarrera/getDatosRuta/${ruta}`;
    await axios
      .get(url)
      .then((res) => {
        setIdRuta(ruta);
        setDistancia(res.data.distancia);
        setTiempo(res.data.tiempo);
        setAltitud(res.data.altitud);
        setRutaStrava(res.data.link);
      })
      .catch((err) => console.error(err));
  }

  const handleRutaStrava = (e) => {
    setRutaStrava(e);
  }

  const saveRuta = async () => {
    if (!distancia || !tiempo || !altitud) {
      toast("Todos los campos deben tener un valor.", "warning");
      return;
    }

    var _fecha = new Date(fechaCarrera).toISOString();
    const datos = {
      fecha: _fecha,
      IdCarrera: 0,
      IdRuta: idRuta,
      Distancia: distancia,
      TiempoMov: tiempo,
      Altitud: altitud,
      LinkRuta: rutaStrava,
    };

    await axios
      .post(variables.API_URL + "DatosCarrera/saveRuta", datos, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        toast("La información se ha actualizado de forma correcta.");
        loadRutas();
        setOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const save = async () => {
    setDisabledOk(true);

    const validos = validInfo();

    if (!validos) {
      setDisabledOk(false);
      setDisplay("block");
      return;
    } else {
      setDisplay("none");
    }

    const dataForm = {
      FechaCarrera: fechaCarrera,
      TextFecha: fechaTexto,
      NombrePista: pista,
      TextUbicacion: ubicacion,
      Strava: strava,
      LinkUbicacion: linkPista,
      LogoEquipo: logoName,
      Banco: banco,
      NomBeneficiario: benef,
      NumTarjeta: cardNumber,
      Clabe: clabe,
      Precio: precio,
      FechaCierre: fechaCierre,
      HoraCierre: horaCierre,
      FechaRecon1: fecRecon1,
      horaRecon1: horaRec1,
      FechaRecon2: fecRecon2,
      horaRecon2: horaRec2,
      DocConvoca: docConvocaName,
      ImagenFondo: imagenName,
    };

    await axios
      .post(variables.API_URL + "DatosCarrera/SaveEntity", dataForm, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(async (res) => {
        toast("La información se ha actualizado de forma correcta.");
        setDisabledOk(false);
        if (
          (logoName != "" || imagenName != "" || docConvocaName != "") &&
          res.status === 200
        ) {
          return await saveFiles();
        }
      })
      .catch((error) => {
        setDisabledOk(false);
        console.log(error);
      });
  };

  const saveFiles = async () => {
    const formData = new FormData();
    formData.append("logo", logo);
    formData.append("imagen", imagen);
    formData.append("docConvoca", docConvoca);

    await axios
      .post(variables.API_URL + "DatosCarrera/SaveFiles", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data === "1") {
          toast("Se han registrado los archivos de forma correcta");
        } else {
          toast("Las imagenes o el documento no se registro.", "warning");
        }
      });
  };

  useEffect(() => {}, [validSession()]);

  return (
    <>
      <div
        style={{
          backgroundImage: "url(Images/datosCarrera.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100%",
          height: "auto",
          top: 0,
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <center>
          <HeadingGroup>
            <Heading>Datos de la Carrera</Heading>
            <Text muted>
              Configuración requerida para mostrarse en las Inscripciones
            </Text>
            <Button
              appearance="ghost"
              className="w-100"
              color="blue"
              style={{ border: "none", fontSize: "22px" }}
              onClick={() => {
                window.history.go(-1);
              }}
            >
              Regresar a menú
            </Button>
          </HeadingGroup>
        </center>
        <div
          className="container"
          style={{
            marginTop: "10px",
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: "10px",
            backgroundColor: "#e0e2e4",
            padding: "20px",
          }}
        >
          <div className="App">
            <div className="App container">
              <div className="card" style={{ padding: "10px" }}>
                <Heading
                  level={5}
                  style={{
                    backgroundColor: "#32a5c6",
                    color: "white",
                    borderRadius: "5px",
                  }}
                >
                  &nbsp; Datos Iniciales
                </Heading>
                <div className="card-body" style={{ opacity: "0.90" }}>
                  <div className="row mb-2">
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Fecha del Evento o Carrera</b>
                      <DateInput
                        format="dd/MM/yyyy"
                        id="fecha"
                        name="fecha"
                        autoFocus="true"
                        onChange={(e) => setFechaCarrera(e)}
                        onBlur={getDataCarrera}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        * Campo requerido
                      </Form.HelpText>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Texto de la fecha</b>
                      <Input
                        placeholder="Ej: DOMINGO 02 DE ENERO DE 2025"
                        onFocus={() => formatStringDate()}
                        value={fechaTexto}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        * Campo requerido
                      </Form.HelpText>
                    </div>
                    <div className="col-lg-3 col-lg-3 col-sm-3">
                      <b>Nombre de la Pista</b>
                      <Input
                        value={pista}
                        onChange={(e) => handleInput("pista", e)}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        * Campo requerido
                      </Form.HelpText>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <b>Localidad y Municipio o Delegación</b>
                      <Input
                        value={ubicacion}
                        onChange={(e) => handleInput("ubicacion", e)}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Ruta(s) de la Carrera: ({numRutas})</b>
                      <SelectPicker
                        data={rutas}
                        style={{ width: "100%" }}
                        searchable={false}
                        onChange={(e) => addRuta(e)}
                        placeholder="Selecciona una ruta"
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Link de la ubicación (Pista)</b>
                      <Input
                        value={linkPista}
                        onChange={(e) => setLinkPista(e)}
                      />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Logo (Formato PNG)</b>
                      {editLogo ? (
                        <InputGroup>
                          <Input value={logoName} readOnly />
                          <InputGroup.Addon>
                            <LuFileEdit
                              onClick={() => setEditLogo(false)}
                              style={{ cursor: "pointer" }}
                            />
                          </InputGroup.Addon>
                        </InputGroup>
                      ) : (
                        <input
                          type="file"
                          id="logo"
                          accept=".png"
                          onChange={handleChangeLogo}
                        />
                      )}
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Imagen de Fondo (Formato JPG)</b>
                      {editImagen ? (
                        <InputGroup>
                          <Input value={imagenName} readOnly />
                          <InputGroup.Addon>
                            <LuFileEdit
                              onClick={() => setEditImagen(false)}
                              style={{ cursor: "pointer" }}
                            />
                          </InputGroup.Addon>
                        </InputGroup>
                      ) : (
                        <input
                          type="file"
                          id="imgFondo"
                          accept=".jpg"
                          onChange={handleChangeImagen}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" style={{ padding: "10px" }}>
                <Heading
                  level={5}
                  style={{
                    backgroundColor: "#32a5c6",
                    color: "white",
                    borderRadius: "5px",
                  }}
                >
                  &nbsp; Datos Bancarios
                </Heading>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Nombre del Banco</b>
                      <Input
                        value={banco}
                        onChange={(e) => handleInput("banco", e)}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Precio de la Carrera</b>
                      <InputNumber
                        value={precio}
                        onChange={(e) => setPrecio(e)}
                        min={0}
                        style={{ textAlign: "center" }}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-lg-3 col-md-3 col-sm-3">
                      <b>Nombre del Beneficiario</b>
                      <Input
                        id="benef"
                        value={benef}
                        onChange={(e) => handleInput("benef", e)}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        * Campo requerido
                      </Form.HelpText>
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>No. de Tarjeta</b>
                      <Input
                        id="tarjeta"
                        maxLength={16}
                        value={cardNumber}
                        onChange={(e) => onHandleCardNumberChange("tarjeta", e)}
                        onBlur={() => formatCardNumber()}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        {invalidCard}
                      </Form.HelpText>
                    </div>
                    <div className="text-center col-lg-2 col-md-2 col-sm-2">
                      <b>Formato No. de Tarjeta</b>
                      <Input
                        value={formatCard}
                        readOnly
                        style={{
                          border: "none",
                          fontWeight: "600",
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>CLABE Interbancaria</b>
                      <Input
                        id="clabe"
                        maxLength={18}
                        value={clabe}
                        onChange={(e) => onHandleCardNumberChange("clabe", e)}
                        onBlur={() => formatClabe()}
                      />
                      <Form.HelpText style={{ color: "red" }}>
                        {invalidClabe}
                      </Form.HelpText>
                    </div>
                    <div className="text-center col-lg-3 col-md-3 col-sm-3">
                      <b>Formato No. de CLABE</b>
                      <Input
                        value={clabeFormato}
                        readOnly
                        style={{
                          border: "none",
                          fontWeight: "600",
                          fontSize: "16px",
                          textAlign: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" style={{ padding: "10px" }}>
                <Heading
                  level={5}
                  style={{
                    backgroundColor: "#32a5c6",
                    color: "white",
                    borderRadius: "5px",
                  }}
                >
                  &nbsp; Datos Complementarios
                </Heading>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Fec Cierre Inscripciones</b>
                      <Stack
                        spacing={10}
                        direction="column"
                        alignItems="flex-start"
                      >
                        {editando ? (
                          <InputGroup>
                            <Input value={fechaCierre} readOnly />
                            <InputGroup.Addon>
                              <LuFileEdit
                                onClick={() => setEditando(false)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputGroup.Addon>
                          </InputGroup>
                        ) : (
                          <DatePicker
                            format="dd.MM.yyyy"
                            value={fechaCierre}
                            onChange={(e) => setFecCierre(e)}
                          />
                        )}
                      </Stack>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1">
                      <b>Hora Cierre</b>
                      <input
                        className="form-control"
                        value={horaCierre}
                        placeholder="00:00"
                        maxLength={5}
                        onChange={(e) =>
                          setHoraCierre(maskTime(e.target.value))
                        }
                        style={{ textAlign: "center" }}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Fecha Reconocimiento (1)</b>
                      <Stack
                        spacing={10}
                        direction="column"
                        alignItems="flex-start"
                      >
                        {editFecRecon1 ? (
                          <InputGroup>
                            <Input value={fecRecon1} readOnly />
                            <InputGroup.Addon>
                              <LuFileEdit
                                onClick={() => setEditFecRecon1(false)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputGroup.Addon>
                          </InputGroup>
                        ) : (
                          <DatePicker
                            format="dd.MM.yyyy"
                            value={fecRecon1}
                            onChange={(e) => setFecRecon1(e)}
                          />
                        )}
                      </Stack>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1">
                      <b>Hora Inicio</b>
                      <input
                        className="form-control"
                        value={horaRec1}
                        placeholder="00:00"
                        maxLength={5}
                        onChange={(e) => setHoraRec1(maskTime(e.target.value))}
                        style={{ textAlign: "center" }}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-sm-2">
                      <b>Fecha Reconocimiento (2)</b>
                      <Stack
                        spacing={10}
                        direction="column"
                        alignItems="flex-start"
                      >
                        {editFecRecon2 ? (
                          <InputGroup>
                            <Input value={fecRecon2} readOnly />
                            <InputGroup.Addon>
                              <LuFileEdit
                                onClick={() => setEditFecRecon2(false)}
                                style={{ cursor: "pointer" }}
                              />
                            </InputGroup.Addon>
                          </InputGroup>
                        ) : (
                          <DatePicker
                            format="dd.MM.yyyy"
                            onChange={(e) => setFecRecon2(e)}
                          />
                        )}
                      </Stack>
                    </div>
                    <div className="col-lg-1 col-md-1 col-sm-1">
                      <b>Hora Inicio</b>
                      <input
                        className="form-control"
                        value={horaRec2}
                        placeholder="00:00"
                        maxLength={5}
                        onChange={(e) => setHoraRec2(maskTime(e.target.value))}
                        style={{ textAlign: "center" }}
                      />
                    </div>
                    {/* <div className="col-lg-4 col-md-4 col-sm-4">
                      <b>Documento de Convocatoria (PDF)</b>
                      {editDoc ? (
                        <InputGroup>
                          <Input value={docConvocaName} readOnly />
                          <InputGroup.Addon>
                            <LuFileEdit
                              onClick={() => setEditDoc(false)}
                              style={{ cursor: "pointer" }}
                            />
                          </InputGroup.Addon>
                        </InputGroup>
                      ) : (
                        <input
                          type="file"
                          id="convoca"
                          accept=".pdf"
                          onChange={handleChangeConvoca}
                        />
                      )}
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="card">
                <Message
                  showIcon
                  style={{ display: `${display}` }}
                  type="warning"
                  header="Datos incompletos"
                >
                  Por favor valide los campos incompletos:
                  {camposIncompletos}
                </Message>
                <div className="card-body">
                  <ButtonToolbar style={{ float: "right" }}>
                    <Button
                      appearance="primary"
                      onClick={() => save()}
                      disabled={disabledOk}
                    >
                      &nbsp; Enviar &nbsp;
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        backdrop="static"
        keyboard={true}
        open={open}
        onClose={handleClose}
        overflow={false}
        size={"lg"}
        overflowY={true}
      >
        <Modal.Header>
          <Modal.Title>Agregar Ruta - Datos de Configuración</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row mb-3">
            <div className="col-lg-2 col-md-2 col-sm-2">
              <b>Distancia</b>
              <InputNumber
                value={distancia}
                onChange={(e) => setDistancia(e)}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <b>Tiempo (HH:mm)</b>
              <input
                className="form-control"
                value={tiempo}
                placeholder="00:00"
                maxLength={5}
                onChange={(e) => setTiempo(maskTime(e.target.value))}
                style={{ textAlign: "center" }}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <b>Altitud</b>
              <InputNumber value={altitud} onChange={(e) => setAltitud(e)} />
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <b>Link de Strava</b>
              <Input onChange={(e) => handleRutaStrava(e)} value={rutaStrava} />
            </div>
            <div className="text-end col-lg-2 col-md-2 col-sm-2">
              <br></br>
              <Button onClick={saveRuta} appearance="primary" className="w-100">
                + Guardar
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} appearance="subtle">
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
